module.exports = {"451202001":"金城江街道","451202101":"东江镇","451202102":"六圩镇","451202103":"六甲镇","451202104":"河池镇","451202105":"拔贡镇","451202106":"九圩镇","451202107":"五圩镇","451202200":"白土乡","451202203":"侧岭乡","451202204":"保平乡","451202205":"长老乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451202.json
// module id = 2287
// module chunks = 0